import React from 'react';
import logo from "../images/logo.png";
import "../css/footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section brand-section">
          <img 
            src={logo} 
            alt="Logo" 
            className="footer-logo"
          />
          <div className="contact-info">
            <p><i className="fas fa-map-marker-alt"></i> Panamá</p>
            <p><i className="fas fa-envelope"></i> info@solucionescrypto.com</p>
          </div>
        </div>
        
        <div className="footer-section links-section">
          <h3>Enlaces</h3>
          <ul className="footer-links">
            <li><a href="/quienes-somos">Quiénes Somos</a></li>
            <li><a href="/productos">Productos</a></li>
            <li><a href="/remesas">Remesas</a></li>
            <li><a href="/contacto">Contacto</a></li>
          </ul>
        </div>
        
        <div className="footer-section social-section">
          <h3>Síguenos</h3>
          <div className="social-links">
            <a href="https://www.facebook.com/SolucionesCrypto" target="_blank" rel="noopener noreferrer" className="social-link">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="https://www.instagram.com/solucionescrypto/" target="_blank" rel="noopener noreferrer" className="social-link">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.youtube.com/@Soluciones-Crypto" target="_blank" rel="noopener noreferrer" className="social-link">
              <i className="fab fa-youtube"></i>
            </a>
          </div>
          <p className="copyright">&copy; 2024 Sistema de Pagos</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 